import type React from "react";

const Features: React.FC = () => {
	const features = [
		{
			id: "hybrid",
			title: "オフライン・オンラインのハイブリッド形式",
			description:
				"大船渡市内での対面での活動を基本としながら、オンラインでの参加も可能です。",
			icon: "🏢",
		},
		{
			id: "mentor",
			title: "経験豊富なメンターによるサポート",
			description:
				"各分野の経験者がメンターとして参加し、学習の方向性や技術的アドバイスを提供します。",
			icon: "👨‍🏫",
		},
		{
			id: "community",
			title: "活発なコミュニティ活動",
			description:
				"定期的な交流会やイベントを通じて、メンバー同士の繋がりを深めます。",
			icon: "🤝",
		},
		{
			id: "flexible",
			title: "柔軟な学習スタイル",
			description:
				"自分のペースで学習を進められ、興味のある分野を自由に選択できます。",
			icon: "📚",
		},
	];

	return (
		<section className="mb-16">
			<h2 className="text-3xl font-semibold mb-6">学習ギルドの特徴</h2>
			<div className="grid md:grid-cols-2 gap-8">
				{features.map((feature) => (
					<div key={feature.id} className="bg-white p-6 rounded-lg shadow-md">
						<div className="flex items-center mb-4">
							<span className="text-2xl mr-3">{feature.icon}</span>
							<h3 className="text-xl font-semibold">{feature.title}</h3>
						</div>
						<p className="text-gray-700">{feature.description}</p>
					</div>
				))}
			</div>
		</section>
	);
};

export default Features;
